// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "public/css/" + chunkId + "." + {"1018":"0c76fd67dd9147a3a4a8","1981":"f7afa03d321a4d2cf7c3","9329":"d1d287a8a26e1182d13c"}[chunkId] + ".css";
};